import { StackScreenProps } from "@react-navigation/stack";
import { ShiftRootParamList } from "../../../../types";
import {
  Card,
  FlatActionList,
  TextButton,
  Page,
} from "@towersystems/roam-common-native";
import { useEndOfShiftContextProvider } from "../../utils/shift/hooks";
import dayjs from "dayjs";
import { dateFormat, timeFormat } from "../../utils/shift/constants";
import { OfflineBanner } from "../../../../components/OfflineBanner/OfflineBanner";
import useOnline from "@towersystems/roam-common-native/lib/utilities/use-online";
import { useTranslation } from "../../../../utilities/i18n";

export interface ShiftLandingScreenProps
  extends StackScreenProps<ShiftRootParamList, "ShiftLandingScreen"> {}

export const ShiftLandingScreen = ({ navigation }: ShiftLandingScreenProps) => {
  const { t } = useTranslation("end_of_shift");
  const { shiftTerminal } = useEndOfShiftContextProvider();
  const terminalOpen = shiftTerminal.openTerminalClosureId !== null;

  const online = useOnline();

  const onNavigate = () => {
    if (terminalOpen) {
      navigation.navigate("OpenShiftScreen");
    } else {
      navigation.navigate("StartNewShiftScreen");
    }
  };

  const openedDate = dayjs(shiftTerminal.terminalOpenTime).format(dateFormat);
  const openedTime = dayjs(shiftTerminal.terminalOpenTime).format(timeFormat);

  const title = t("shift_landing_title");
  const secondaryTitle = t("shift_landing_subtitle");

  if (!online) {
    return (
      <Page title={title} secondaryTitle="secondaryTitle">
        <OfflineBanner />
      </Page>
    );
  }

  return (
    <Page title={title} secondaryTitle={secondaryTitle}>
      <Card>
        <FlatActionList
          items={[
            {
              key: "new_shift",
              title: terminalOpen
                ? t("action.view_shift.label", {
                    name: shiftTerminal.name,
                  })
                : t("action.new_shift.label", {
                    name: shiftTerminal.name,
                  }),
              subTitle: terminalOpen
                ? t("action.view_shift.description", {
                    date: openedDate,
                    time: openedTime,
                  })
                : undefined,
              onPress: onNavigate,
              componentRight: () => {
                return (
                  <TextButton onPress={onNavigate}>
                    {terminalOpen
                      ? t("action.view_shift.placeholder")
                      : t("action.new_shift.placeholder")}
                  </TextButton>
                );
              },
            },
            {
              key: "shift_history",
              title: t("action.shift_history.label"),
              subTitle: t("action.shift_history.description"),
              onPress: () => navigation.navigate("ShiftHistoryScreen"),
            },
          ]}
        />
      </Card>
    </Page>
  );
};
